import Api from '.';

/**
 *
 * Sends a CEP and receives an Address.
 * @param {string} cep
 */
export function getAddress(cep) {
  return Api.get(`/cep/${cep}`);
}
